import { useQuery } from "@tanstack/react-query";

import { getInvitationPreview, type InvitationPreview } from "./api";

export const useInvitationPreviewQuery = (token: string | null) =>
  useQuery<InvitationPreview>({
    queryKey: ["invitation-preview", token],
    queryFn: () => getInvitationPreview(token as string),
    enabled: Boolean(token),
    retry: false,
  });
